<template>
  <div v-if="loading" class="skeleton-container" aria-busy="true" aria-live="polite">
    <div v-for="row in rows" :key="row" class="skeleton-row">
      <div
        v-for="col in cols"
        :key="col"
        class="skeleton-cell"
        :style="{ width: getCellWidth(col) }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    loading: { type: Boolean, default: true },
    rows: { type: Number, default: 5 },
    cols: { type: Number, default: 4 }
  },
  methods: {
    getCellWidth (col) {
      const widths = ['30%', '20%', '25%', '15%', '10%', '15%']
      return widths[(col - 1) % widths.length]
    }
  }
}
</script>

<style scoped>
.skeleton-container {
  width: 100%;
}
.skeleton-row {
  display: flex;
  gap: 12px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-default);
}
.skeleton-cell {
  height: 20px;
  background-color: var(--bg-muted);
  border-radius: 4px;
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}
@keyframes skeleton-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>